/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function parsePostcodeUploadText(text: string): string[] {
  return _.chain(String(text || '').replace(/^\uFEFF/, '').split(/[\n\r,;\t]+/))
    .map((value) => value.trim().replace(/^"(.*)"$/, '$1').trim())
    .filter()
    .value();
}
